




















































import { Component, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";

interface MasterCard {
  name: string;
  title: string;
  subtitle: string;
  desc: string;
  icon: string;
  color: string;
  privilegeAny: { domain: string; action?: string }[];
}

@Component
export default class MasterReferensiMenuPage extends Vue {
  readonly masters: MasterCard[] = [
    {
      name: "master-jenis-berkas",
      title: "Kategori Berkas RM",
      subtitle: "Master jenis berkas manual RM",
      desc:
        "Kelola kategori & subkategori berkas scan pasien (RM lama, KTP, KK, BPJS, consent). Hierarki 2 tingkat.",
      icon: "mdi-folder-cog",
      color: "indigo",
      privilegeAny: [{ domain: "master_jenis_berkas" }]
    },
    {
      name: "alat-reuse-master",
      title: "Master Alat Reuse",
      subtitle: "Alat single-use reprocessing",
      desc:
        "Daftar alat single-use yang boleh di-reuse beserta batas maksimal penggunaan, metode sterilisasi, dan status aktif.",
      icon: "mdi-recycle-variant",
      color: "green",
      privilegeAny: [{ domain: "master_alat_reuse" }]
    },
    {
      name: "ref-askep",
      title: "Ref Askep",
      subtitle: "Referensi Asuhan Keperawatan",
      desc:
        "Master diagnosis, intervensi, luaran, tanda/gejala, dan etiologi keperawatan (SDKI / SIKI / SLKI).",
      icon: "mdi-file-document-edit-outline",
      color: "teal",
      privilegeAny: [{ domain: "master_ref_askep" }]
    },
    {
      name: "general-document",
      title: "General Document",
      subtitle: "Dokumen umum & panduan",
      desc:
        "Unggah & kelola dokumen umum rumah sakit yang tampil pada drawer Panduan bagi seluruh pengguna.",
      icon: "mdi-book-open-variant",
      color: "blue",
      privilegeAny: [{ domain: "master_general_document" }]
    },
    {
      name: "tim-penguji-kesehatan",
      title: "Tim Penguji Kesehatan",
      subtitle: "Form 77",
      desc:
        "Master susunan Tim Penguji Kesehatan (Ketua, Anggota, NGT) yang di-snapshot saat Form 77 dibuat.",
      icon: "mdi-clipboard-account",
      color: "deep-purple",
      privilegeAny: [{ domain: "master_tim_penguji" }]
    }
  ];

  get visibleMasters(): MasterCard[] {
    return this.masters.filter(m =>
      m.privilegeAny.some(p => userModule.hasPrivilege(p.domain, p.action || "view"))
    );
  }

  goto(name: string) {
    if (this.$route.name !== name) {
      this.$router.push({ name });
    }
  }
}
